import React, { useEffect, useMemo, useState } from "react";
import { getUpcomingFollowups } from "../../../services/dashboardService";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import { hasPermission } from "../../../utils/commonutils";
import { RightDrawer, ModalHeader, ModalBody, ModalFooter } from "../../CommonComponents/RightDrawer";
import { Button } from "../../Inquiary/components/common/Button";
import { FormField, TextArea, TextInput } from "../../Inquiary/components/common/FormInput";
import { FALLBACK_FOLLOWUP_OUTCOME, FALLBACK_FOLLOWUP_TYPE } from "../../../utils/masterFallbacks";
import MasterSelect from "../../CommonComponents/MasterSelect";
import { updateFollowup } from "../../../services/InqairyService";
import { updateModuleFollowup } from "../../../services/moduleFollowupService";
import { editFollowup } from "../../../services/Follwupservices";
import { toastAlert } from "../../../helpers/toastAlert";

const pathFor = (item) => {
  const moduleName = String(item.module || "").toLowerCase();
  const id = item.recordId;
  if (moduleName === "inquiry" && id) return `/inquiriedetail/${id}`;
  if (moduleName === "task") return "/tasks";
  if (moduleName.includes("payment")) return "/payment";
  if (moduleName.includes("case") || moduleName === "gst") return "/casemanagement";
  if (moduleName.includes("communication")) return "/communication";
  return "/follow-up";
};

const dateInput = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
};

const TodaysFollowups = (props) => {
  const [followups, setFollowups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ type: "Call", outcome: "In Progress", notes: "", nextFollowupDate: "" });
  const canOpenFollowups = hasPermission("read_followup") || hasPermission("read_inquiry");

  const load = async () => {
    setLoading(true);
    const response = await getUpcomingFollowups(props);
    setFollowups(response?.data?.items || []);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const buckets = useMemo(() => {
    const todayItems = [];
    const overdue = [];
    const upcoming = [];
    followups.forEach((item) => {
      if (item.bucket === "today") todayItems.push(item);
      else if (item.bucket === "overdue") overdue.push(item);
      else upcoming.push(item);
    });
    return { todayItems, overdue, upcoming };
  }, [followups]);

  const openItem = (item) => {
    setSelected(item);
    setForm({
      type: item.type || "Call",
      outcome: item.outcome || item.status || "In Progress",
      notes: item.notes || "",
      nextFollowupDate: dateInput(item.date),
    });
  };

  const saveItem = async () => {
    if (!selected) return;
    setSaving(true);
    const nextDate = form.nextFollowupDate;
    const moduleName = String(selected.module || "").toLowerCase();
    let res;
    try {
      if (moduleName === "inquiry") {
        res = await updateFollowup(props, selected.id, {
          inquiryId: selected.recordId,
          type: form.type,
          outcome: form.outcome,
          notes: form.notes,
          nextFollowupDate: nextDate,
        });
      } else if (moduleName === "task") {
        res = await editFollowup(
          props,
          {
            title: selected.title,
            date: nextDate,
            time: selected.time || "12:00 AM",
            note: form.notes,
            status: form.outcome,
            employee: { _id: undefined },
          },
          selected.id,
        );
      } else {
        res = await updateModuleFollowup(props, selected.id, {
          type: form.type,
          outcome: form.outcome,
          notes: form.notes,
          nextFollowupDate: nextDate,
          module: selected.module,
          recordId: selected.recordId,
        });
      }
      if (res?.status || res?.code === 200 || res?.code === 201 || res?.data?.status) {
        toastAlert("Follow-up saved", "success");
        setSelected(null);
        load();
      } else {
        toastAlert(res?.message || res?.data?.message || "Could not save follow-up", "error");
      }
    } catch (err) {
      toastAlert("Could not save follow-up", "error");
    }
    setSaving(false);
  };

  const Column = ({ title, items, danger }) => (
    <div>
      <div className="followup-col-title">
        {title}
        <span className={`count-badge ${danger ? "danger" : ""}`}>{items.length}</span>
      </div>
      {items.length === 0 && (
        <div className="text-sm text-slate-500 py-4">Nothing here.</div>
      )}
      {items.map((item) => (
        <button
          type="button"
          className="mini-follow-card"
          key={item.id}
          onClick={() => openItem(item)}
          style={{ width: "100%", textAlign: "left", cursor: "pointer", border: 0 }}
        >
          <div className="font-bold text-slate-900">{item.title || "Follow-up"}</div>
          <div className="text-xs text-slate-500 mt-1">
            {item.time || (item.date ? new Date(item.date).toLocaleDateString("en-IN") : "")}
            {item.assignedTo ? ` · ${item.assignedTo}` : ""}
          </div>
          <div className="mt-2 flex gap-2">
            <span className="status-pill" style={{ background: "#e8eef8", color: "#1a3366" }}>
              {String(item.module || "").replaceAll("_", " ")}
            </span>
            {item.status && <span className="status-pill done">{item.status}</span>}
          </div>
        </button>
      ))}
    </div>
  );

  if (!canOpenFollowups) return null;

  return (
    <div className="card-main" id="dashboard-followups" style={{ marginTop: 12 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>Follow-ups</div>
        <button
          type="button"
          className="schedule-link"
          onClick={() => props.history.push(hasPermission("read_followup") ? "/follow-up" : "/inquiary")}
        >
          View all
        </button>
      </div>
      {loading ? (
        <div className="text-slate-500">Loading…</div>
      ) : (
        <div className="followup-board">
          <Column title="Today" items={buckets.todayItems} />
          <Column title="Overdue" items={buckets.overdue} danger />
          <Column title="Upcoming" items={buckets.upcoming} />
        </div>
      )}

      <RightDrawer isOpen={Boolean(selected)} onClose={() => setSelected(null)} size="md">
        <ModalHeader kicker={String(selected?.module || "follow-up").replaceAll("_", " ")} toggle={() => setSelected(null)}>
          {selected?.title || "Follow-up"}
        </ModalHeader>
        <ModalBody>
          {selected && (
            <>
              <div className="assign-banner" style={{ marginTop: 0 }}>
                {selected.assignedTo ? `Assigned · ${selected.assignedTo}` : "Follow-up"}
                {selected.relatedTo ? ` · ${selected.relatedTo}` : ""}
              </div>
              {selected.phone && (
                <div className="flex flex-wrap gap-2 mb-3">
                  <a className="quick-action" href={`tel:${selected.phone}`}>Call {selected.phone}</a>
                  <a
                    className="quick-action"
                    href={`https://wa.me/91${String(selected.phone).replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    WhatsApp
                  </a>
                </div>
              )}
              <div className="field-box mb-3">
                Current date: {selected.date ? new Date(selected.date).toLocaleString("en-IN") : "—"}
              </div>
              <div className="space-y-3">
                <FormField label="Type">
                  <MasterSelect
                    variant="inquiry"
                    group="followup_type"
                    fallback={FALLBACK_FOLLOWUP_TYPE}
                    value={form.type}
                    onChange={(e) => setForm({ ...form, type: e.target.value })}
                  />
                </FormField>
                <FormField label="Outcome / status">
                  <MasterSelect
                    variant="inquiry"
                    group="followup_outcome"
                    fallback={FALLBACK_FOLLOWUP_OUTCOME}
                    value={form.outcome}
                    onChange={(e) => setForm({ ...form, outcome: e.target.value })}
                  />
                </FormField>
                <FormField label="Notes">
                  <TextArea
                    rows={3}
                    value={form.notes}
                    onChange={(e) => setForm({ ...form, notes: e.target.value })}
                    placeholder="What was discussed?"
                  />
                </FormField>
                <FormField label="Schedule next follow-up">
                  <TextInput
                    type="date"
                    value={form.nextFollowupDate}
                    onChange={(e) => setForm({ ...form, nextFollowupDate: e.target.value })}
                  />
                </FormField>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={() => selected && props.history.push(pathFor(selected))}>
            Open record
          </Button>
          <div className="flex gap-2">
            <Button variant="secondary" onClick={() => setSelected(null)}>Cancel</Button>
            <Button disabled={saving} onClick={saveItem}>
              {saving ? "Saving…" : "Update"}
            </Button>
          </div>
        </ModalFooter>
      </RightDrawer>
    </div>
  );
};

export default withRouter(connect((state) => ({ authData: state.authReducer }))(TodaysFollowups));
